import { render, staticRenderFns } from "./BundlesList.vue?vue&type=template&id=33c89052"
import script from "./BundlesList.vue?vue&type=script&lang=js"
export * from "./BundlesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports